export const sections = [
  {
    key: 'quantitiesHandled',
    label: 'Quantities Handled',
  },
  {
    key: 'numberOfWorkers',
    label: 'Number of Workers',
  },
  {
    key: 'shareOfMinerals',
    label: 'Share of Minerals in Activity',
  },
];
